import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../features/modalSLice";
import { useAuthorization } from "../../../hooks/useAuthorization";
import AddChartCategory from "./AddChartCategory";
import {
  getAccountCategories,
  unsetAccountCategories,
} from "../../../features/accountsSlice";
import Loading from "../../../components/loading/Loading";
import Modal from "../../../components/modal/Modal";
import MainContainer from "../../../components/container/MainContainer";
import LocationHeader from "../../../components/header/LocationHeader";
import Table from "../../../components/tables/Table";
import { useLocation } from "react-router-dom";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const ChartCategory = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const categories = useSelector((state) => state.accounts.accountCategories);
  const loading = useSelector(
    (state) => state.accounts.load.getAccountCategories
  );
  const { isAuthorized } = useAuthorization();

  const title = "Account Categories";
  // const links = [{ to: "/countries", name: "Countries" }];

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Name" },
    { id: "account_type", text: "Account Type" },
  ];

  const openAddAccountModal = () => {
    dispatch(openModal(<AddChartCategory />));
  };

  useEffect(() => {
    dispatch(getAccountCategories());
    return () => {
      dispatch(unsetAccountCategories());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer>
        <LocationHeader
          title={title}
          links={[]}
          action={openAddAccountModal}
          authorized={isAuthorized("settings", "create")}
        />
        <main className="table-container">
          <Table columns={columns} data={categories} link />
        </main>
      </MainContainer>
    </>
  );
};

export default ChartCategory;
